// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/images/webp/meetings-bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullscreen-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px); 
  -webkit-backdrop-filter: blur(10px); 
  background: rgba(0, 0, 0, 0.6) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center; 
  background-size: cover; 
  z-index: 999;
}

.form-container {
  width: 95%;
  max-width: 500px;
  min-height: 600px;
  padding: 3rem 2.5rem;
  background: #111827;
  border-radius: 24px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  text-align: center;
  border: 1px solid rgba(43, 184, 221, 0.2);
  position: relative;
  overflow: hidden;
}

.form-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(43, 184, 221, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

.form-container h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2bb8dd;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 0rem;
}

form input {
  width: 100%;
  padding: 1.25rem 1.5rem;
  border: 2px solid #374151;
  border-radius: 12px;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
  color: #e5e7eb;
  transition: all 0.3s ease;
  font-family: inherit;
  box-sizing: border-box;
}

form input:focus {
  outline: none;
  border-color: #2bb8dd;
  box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.2);
  transform: translateY(-2px);
}

form input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.form-btn {
  width: 100%;
  padding: 1.5rem 2rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
  box-shadow: 0 10px 30px rgba(43, 184, 221, 0.3);
  position: relative;
  overflow: hidden;
}

.form-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.form-btn:hover::before {
  left: 100%;
}

.form-btn:hover {
  background: linear-gradient(135deg, #1e90b8 0%, #2bb8dd 100%);
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.4);
}

.error {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 1rem 1.25rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.text-center {
  text-align: center;
}

.mt-3 {
  margin-top: 1rem;
}

.forgot-link {
  color: #2bb8dd;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
  font-size: 0.95rem;
}

.forgot-link:hover {
  color: #1e90b8;
  text-decoration: underline;
}

.form-container p {
  color: #d1d5db;
  font-size: 1rem;
  margin: 1.5rem 0;
  font-weight: 400;
}

.toggle-link {
  color: #2bb8dd;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
  transition: all 0.2s ease;
}

.toggle-link:hover {
  color: #1e90b8;
}

.home-link {
  color: #9ca3af;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;
  transition: all 0.2s ease;
  font-size: 0.95rem;
}

.home-link:hover {
  color: #d1d5db;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-container {
    width: 90%;
    max-width: 450px;
    min-height: 550px;
    padding: 2.5rem 2rem;
  }
  
  .form-container h2 {
    font-size: 2.2rem;
  }
  
  form input {
    padding: 1.1rem 1.25rem;
    font-size: 1rem;
  }
  
  .form-btn {
    padding: 1.25rem 1.75rem;
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .form-container {
    width: 95%;
    max-width: 400px;
    min-height: 500px;
    padding: 2rem 1.5rem;
    border-radius: 20px;
  }
  
  .form-container h2 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
  
  form {
    gap: 1.25rem;
  }
  
  form input {
    padding: 1rem 1.25rem;
    font-size: 0.95rem;
  }
  
  .form-btn {
    padding: 1.1rem 1.5rem;
    font-size: 1rem;
  }
  
  .form-container p {
    font-size: 0.9rem;
    margin: 1.25rem 0;
  }
}

/* Enhanced animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-container {
  animation: fadeInUp 0.6s ease-out;
}

/* Form validation styles */
form input:invalid {
  border-color: #ef4444;
}

form input:valid:not(:placeholder-shown) {
  border-color: #10b981;
}

/* Selection styles */
form input::selection {
  background: rgba(43, 184, 221, 0.3);
}

/* Focus states for accessibility */
.toggle-link:focus,
.home-link:focus,
.forgot-link:focus {
  outline: 2px solid #2bb8dd;
  outline-offset: 2px;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SignInSignUp.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,8FAA4G;EAC5G,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iFAAiF;EACjF,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,mCAAmC;AACrC;;AAEA,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".fullscreen-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backdrop-filter: blur(10px); \n  -webkit-backdrop-filter: blur(10px); \n  background: rgba(0, 0, 0, 0.6) url(../../public/assets/images/webp/meetings-bg.webp) no-repeat center center; \n  background-size: cover; \n  z-index: 999;\n}\n\n.form-container {\n  width: 95%;\n  max-width: 500px;\n  min-height: 600px;\n  padding: 3rem 2.5rem;\n  background: #111827;\n  border-radius: 24px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);\n  text-align: center;\n  border: 1px solid rgba(43, 184, 221, 0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.form-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(43, 184, 221, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.form-container h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2bb8dd;\n  margin-bottom: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin-bottom: 0rem;\n}\n\nform input {\n  width: 100%;\n  padding: 1.25rem 1.5rem;\n  border: 2px solid #374151;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);\n  color: #e5e7eb;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\nform input:focus {\n  outline: none;\n  border-color: #2bb8dd;\n  box-shadow: 0 0 0 4px rgba(43, 184, 221, 0.2);\n  transform: translateY(-2px);\n}\n\nform input::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.form-btn {\n  width: 100%;\n  padding: 1.5rem 2rem;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #ffffff;\n  background: linear-gradient(135deg, #2bb8dd 0%, #1e90b8 100%);\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n  box-shadow: 0 10px 30px rgba(43, 184, 221, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.form-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.form-btn:hover::before {\n  left: 100%;\n}\n\n.form-btn:hover {\n  background: linear-gradient(135deg, #1e90b8 0%, #2bb8dd 100%);\n  transform: translateY(-3px);\n  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.4);\n}\n\n.error {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  padding: 1rem 1.25rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.mt-3 {\n  margin-top: 1rem;\n}\n\n.forgot-link {\n  color: #2bb8dd;\n  text-decoration: none;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  font-size: 0.95rem;\n}\n\n.forgot-link:hover {\n  color: #1e90b8;\n  text-decoration: underline;\n}\n\n.form-container p {\n  color: #d1d5db;\n  font-size: 1rem;\n  margin: 1.5rem 0;\n  font-weight: 400;\n}\n\n.toggle-link {\n  color: #2bb8dd;\n  cursor: pointer;\n  text-decoration: underline;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.toggle-link:hover {\n  color: #1e90b8;\n}\n\n.home-link {\n  color: #9ca3af;\n  cursor: pointer;\n  text-decoration: underline;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  font-size: 0.95rem;\n}\n\n.home-link:hover {\n  color: #d1d5db;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .form-container {\n    width: 90%;\n    max-width: 450px;\n    min-height: 550px;\n    padding: 2.5rem 2rem;\n  }\n  \n  .form-container h2 {\n    font-size: 2.2rem;\n  }\n  \n  form input {\n    padding: 1.1rem 1.25rem;\n    font-size: 1rem;\n  }\n  \n  .form-btn {\n    padding: 1.25rem 1.75rem;\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .form-container {\n    width: 95%;\n    max-width: 400px;\n    min-height: 500px;\n    padding: 2rem 1.5rem;\n    border-radius: 20px;\n  }\n  \n  .form-container h2 {\n    font-size: 2rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  form {\n    gap: 1.25rem;\n  }\n  \n  form input {\n    padding: 1rem 1.25rem;\n    font-size: 0.95rem;\n  }\n  \n  .form-btn {\n    padding: 1.1rem 1.5rem;\n    font-size: 1rem;\n  }\n  \n  .form-container p {\n    font-size: 0.9rem;\n    margin: 1.25rem 0;\n  }\n}\n\n/* Enhanced animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.form-container {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n/* Form validation styles */\nform input:invalid {\n  border-color: #ef4444;\n}\n\nform input:valid:not(:placeholder-shown) {\n  border-color: #10b981;\n}\n\n/* Selection styles */\nform input::selection {\n  background: rgba(43, 184, 221, 0.3);\n}\n\n/* Focus states for accessibility */\n.toggle-link:focus,\n.home-link:focus,\n.forgot-link:focus {\n  outline: 2px solid #2bb8dd;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
